import { useState } from "react";
import { useUserStore } from "@/store/UserStore";
import { Button } from "@/components/ui/Button";
import { Input } from "@/components/ui/Input";
import { toast } from "sonner";
import {
  User,
  // Phone,
  Calendar,
  ChevronRight,
  UserCircle,
  Check,
  X as XIcon,
} from "lucide-react";

export function Profile() {
  const { username } = useUserStore();
  const displayName = username || "未设置";

  // 编辑状态管理
  const [editingField, setEditingField] = useState<string | null>(null);

  // 临时数据状态
  const [tempUsername, setTempUsername] = useState(displayName);
  // const [tempPhone, setTempPhone] = useState("138****8888");
  const [tempDays, setTempDays] = useState("1990-01-01");

  // 保存处理函数
  const handleSave = (field: string) => {
    switch (field) {
      case "username":
        // 这里调用你的 update store 逻辑
        toast.success("用户名修改成功");
        break;
      // case "phone":
      //   toast.success("手机号码修改成功");
      //   break;
      case "days":
        toast.success("日期修改成功");
        break;
    }
    setEditingField(null);
  };

  const handleCancel = () => {
    if (editingField === "username") setTempUsername(displayName);
    // if (editingField === "phone") setTempPhone("138****8888");
    if (editingField === "days") setTempDays("1990-01-01");
    setEditingField(null);
  };

  return (
    <div className="w-full">
      <div className="bg-[#f8f8f8] rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        {/* 1. 用户头像行 */}
        <div className="flex items-center justify-between px-4 pt-2 hover:bg-gray-50 cursor-pointer border-b border-gray-50 transition-colors">
          <div className="flex items-center gap-3">
            <UserCircle className="h-5 w-5 text-gray-600" />
            <span className="text-base text-[#0F0F0F]">用户头像</span>
          </div>
          <div className="flex items-center gap-[26px]">
            <div className="h-8 w-8 rounded-full bg-gray-100 overflow-hidden flex items-center justify-center border border-gray-200">
              <img
                src="/defalutprofile.png"
                alt="avatar"
                className="w-full h-full object-cover"
                onError={(e) => (e.currentTarget.src = "/avatar.svg")}
              />
            </div>
            <ChevronRight className="h-4 w-4 text-gray-300" />
          </div>
        </div>

        {/* 2. 用户名行 */}
        <div className="flex items-center justify-between px-4 pt-2 hover:bg-gray-50 transition-colors border-b border-gray-50 min-h-[60px]">
          <div className="flex items-center gap-3">
            <User className="h-5 w-5 text-gray-600" />
            <span className="text-base text-[#0F0F0F]">用户名</span>
          </div>

          <div className="flex items-center justify-end flex-1 pl-4">
            {editingField === "username" ? (
              <div className="flex items-center gap-2 animate-in fade-in zoom-in-95 duration-200 font-normal text-[#B9BABB]">
                <Input
                  value={tempUsername}
                  onChange={(e) => setTempUsername(e.target.value)}
                  className="h-8 w-32 text-right"
                  autoFocus
                />
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-8 w-8 text-green-600 hover:text-green-700 hover:bg-green-50"
                  onClick={() => handleSave("username")}
                >
                  <Check className="h-4 w-4" />
                </Button>
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-8 w-8 text-gray-400 hover:text-gray-600 hover:bg-gray-100"
                  onClick={handleCancel}
                >
                  <XIcon className="h-4 w-4" />
                </Button>
              </div>
            ) : (
              <div
                className="flex items-center gap-[26px] cursor-pointer group w-full justify-end py-2"
                onClick={() => setEditingField("username")}
              >
                <span className="text-base text-gray-500 group-hover:text-gray-900 transition-colors font-normal text-[#B9BABB]">
                  {tempUsername}
                </span>
                <ChevronRight className="h-4 w-4 text-gray-300 group-hover:text-gray-400" />
              </div>
            )}
          </div>
        </div>

        {/* 3. 手机号行 */}
        {/* <div className="flex items-center justify-between px-4 pt-2 hover:bg-gray-50 transition-colors border-b border-gray-50 min-h-[60px] border-b border-[#E8E8E8]">
          <div className="flex items-center gap-3">
            <Phone className="h-5 w-5 text-gray-600" />
            <span className="text-base text-[#0F0F0F] font-normal">手机号</span>
          </div>

          <div className="flex items-center justify-end flex-1 pl-4">
            {editingField === "phone" ? (
              <div className="flex items-center gap-2 animate-in fade-in zoom-in-95 duration-200 font-normal">
                <Input
                  value={tempPhone}
                  onChange={(e) => setTempPhone(e.target.value)}
                  className="h-8 w-36 text-right font-normal text-[#B9BABB]"
                  autoFocus
                />
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-8 w-8 text-green-600 hover:text-green-700 hover:bg-green-50"
                  onClick={() => handleSave("phone")}
                >
                  <Check className="h-4 w-4" />
                </Button>
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-8 w-8 text-gray-400 hover:text-gray-600 hover:bg-gray-100"
                  onClick={handleCancel}
                >
                  <XIcon className="h-4 w-4" />
                </Button>
              </div>
            ) : (
              <div className="flex items-center gap-[15px] font-normal">
                <span className="text-base text-gray-400 font-medium text-[#B9BABB]">
                  {tempPhone}
                </span>
                <Button
                  onClick={() => onNavigate?.("phoneChange")}
                  className="px-2.5 py-1 bg-gray-100 hover:bg-gray-200 rounded text-xs text-gray-600 transition-colors"
                >
                  更改
                </Button>
              </div>
            )}
          </div>
        </div> */}

        {/* 4. 生日行 */}
        <div className="flex items-center justify-between px-4 pt-2 hover:bg-gray-50 transition-colors cursor-pointer min-h-[60px] border-b border-gray-50">
          <div className="flex items-center gap-3">
            <Calendar className="h-5 w-5 text-gray-600" />
            <span className="text-base text-[#0F0F0F]">生日</span>
          </div>

          <div className="flex items-center justify-end flex-1 pl-4">
            {editingField === "days" ? (
              <div className="flex items-center gap-2 animate-in fade-in zoom-in-95 duration-200 font-normal text-[#B9BABB] text-base">
                <Input
                  type="date"
                  value={tempDays}
                  onChange={(e) => setTempDays(e.target.value)}
                  className="h-8 w-36 font-normal text-[#B9BABB]"
                  autoFocus
                />
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-8 w-8 text-green-600 hover:text-green-700 hover:bg-green-50"
                  onClick={() => handleSave("days")}
                >
                  <Check className="h-4 w-4" />
                </Button>
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-8 w-8 text-gray-400 hover:text-gray-600 hover:bg-gray-100"
                  onClick={handleCancel}
                >
                  <XIcon className="h-4 w-4" />
                </Button>
              </div>
            ) : (
              <div
                className="flex items-center gap-[26px] cursor-pointer group w-full justify-end py-2"
                onClick={() => setEditingField("days")}
              >
                <span className="font-normal text-[#B9BABB] text-base group-hover:text-gray-900 transition-colors">
                  {tempDays}
                </span>
                <ChevronRight className="h-4 w-4 text-gray-300 group-hover:text-gray-400" />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
